import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { ModalContext } from 'App';
import useFormValidator from 'useFormValidator';
import { customStyle } from 'helper';
import * as actions from '../../../action';
import * as c from '../../../constant';

function SubClassificationModal({
  createLandSubClass,
  getLandClassificationsList,
  history,
  getSubClassificationsList,
  getOrdinanceRevisionList,
  ordinanceRevisionList,
  type,
  updateLandSubClass,
  updateList,
  id,
  classificationId,
  ordinanceRevisionId,
}) {
  const [formData, setFormData] = useState({
    code: '',
    description: '',
    unit_value: '',
    ordinance_revision_id: ordinanceRevisionId || '',
  });
  const validateForm = useFormValidator(formData, {
    code: 'required',
    description: 'required',
    unit_value: 'required',
    ordinance_revision_id: 'required',
  });

  useEffect(() => {
    getOrdinanceRevisionList();
  }, []);

  const setModal = useContext(ModalContext);

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSelected = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e.value,
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (type === 'NEW') {
      createLandSubClass(classificationId, formData, ({ data }) => {
        setModal({ isOpen: false });
        getLandClassificationsList();
        history.push(
          `/rpt/land/land-settings/land-classification/${data.attributes.rptax_land_classification_id}`
        );
        getSubClassificationsList(data.attributes.rptax_land_classification_id);
      });
    }

    if (type === 'EDIT') {
      updateLandSubClass(classificationId, id, formData, ({ data }) => {
        setModal({ isOpen: false });
        getLandClassificationsList();
        history.push(
          `/rpt/land/land-settings/land-classification/${data.attributes.rptax_land_classification_id}`
        );
        getSubClassificationsList(data.attributes.rptax_land_classification_id);
      });
    }
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const onSetFormData = () => {
    setFormData(updateList);
  };

  useEffect(() => {
    if (type === 'EDIT') {
      onSetFormData();
    }
  }, []);

  const ordinanceRevisionOptions = ordinanceRevisionList.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Code {validateForm.renderMessage('code')}
            </label>
            <input
              className="form-control"
              type="text"
              name="code"
              onChange={onChange}
              value={_.get(formData, 'code')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Description {validateForm.renderMessage('description')}
            </label>
            <input
              className="form-control"
              type="text"
              name="description"
              onChange={onChange}
              value={_.get(formData, 'description')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Unit Value {validateForm.renderMessage('unit_value')}
            </label>
            <input
              className="form-control"
              type="number"
              name="unit_value"
              onChange={onChange}
              value={_.get(formData, 'unit_value')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label">
              Ordinance Revision: &nbsp;{' '}
              {validateForm.renderMessage('ordinance_revision_id')}
            </label>
            <div>
              <Select
                options={ordinanceRevisionOptions}
                styles={customStyle}
                placeholder="Select Ordinance Revision"
                value={
                  ordinanceRevisionOptions.filter(
                    (item) =>
                      +_.get(formData, 'ordinance_revision_id') ===
                      +_.get(item, 'id')
                  ) || ''
                }
                isDisabled
                onChange={handleSelected('ordinance_revision_id')}
              />
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={!validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

SubClassificationModal.defaultProps = {
  type: '',
  updateList: {},
  id: '',
  classificationId: '',
};

SubClassificationModal.propTypes = {
  type: PropTypes.string,
  id: PropTypes.string,
  classificationId: PropTypes.string,
  updateList: PropTypes.instanceOf(Object),
  getLandClassificationsList: PropTypes.instanceOf(Function).isRequired,
  createLandSubClass: PropTypes.instanceOf(Function).isRequired,
  updateLandSubClass: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSubClassificationsList: PropTypes.instanceOf(Function).isRequired,
  getOrdinanceRevisionList: PropTypes.instanceOf(Function).isRequired,
  ordinanceRevisionList: PropTypes.instanceOf(Array).isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }) => ({
  ordinanceRevisionList: _.get(api, `${c.GET_ORDINANCE_REVISION}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(SubClassificationModal);
